var symphony = symphony || {};

;(function() {

  symphony.videoModal = function() {

	$('.js-video-modal').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});

	//symphony.config.utilities.modal = $.magnificPopup.instance;

  };


})();